import script from "./AttendanceMethods.vue?vue&type=script&setup=true&lang=js"
export * from "./AttendanceMethods.vue?vue&type=script&setup=true&lang=js"

import "./AttendanceMethods.vue?vue&type=style&index=0&id=75fa2e34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75fa2e34"]])

export default __exports__